<template>
  <VContent>
    <VContainer fill-height>
      <VLayout
              style="{max-width:500px;}"
              align-content-center
              mx-auto
              wrap
      >
        <VFlex xs12 sm8 offset-sm2 md5 offset-md4 >
          <BaseCard class="my-3">
            <VCardTitle class="title font-weight-light">
            Sign In
            </VCardTitle>


            <VCardText>
              <UserName />
              <Password  />
            </VCardText>

            <VCardActions>
              <v-btn style="text-transform: none;" text  to="/auth/signup" >
                Sign Up
              </v-btn>
              <VSpacer/>
              <v-btn style="text-transform: none;" text  to="/auth/forgotpassword">
                Forgot Password ?
              </v-btn>

            </VCardActions>

          </BaseCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </VContent>
</template>

<script>
  export default {
    components: {
      UserName: () => import('@/views/auth/UserName'),
      Password: () => import('@/views/auth/Password')
    },
    data: () => ({
      model: 0,
    }),
    mounted () {
      //let l = this.$store.getters['cognito/isLoggedIn'];
    },
  }
</script>
